import { Avatar, AvatarImage, Box, Button, Text } from 'folds';
import { IIdentityProvider, createClient } from 'matrix-js-sdk';
import React, { useMemo, useState, useEffect } from 'react';
import { useAutoDiscoveryInfo } from '../../hooks/useAutoDiscoveryInfo';
import { useInfoDocParams } from '../../hooks/useInfoDocParams';
import buildConfig from '../../../../build.config';

type SSOLoginProps = {
  providers?: IIdentityProvider[];
  redirectUrl: string;
  saveScreenSpace?: boolean;
};
export function SSOLogin({ providers, redirectUrl, saveScreenSpace }: SSOLoginProps) {
  const discovery = useAutoDiscoveryInfo();
  const baseUrl = discovery['m.homeserver'].base_url;
  const mx = useMemo(() => createClient({ baseUrl }), [baseUrl]);
  const infoDocParams = useInfoDocParams();
  const infodoctoken = infoDocParams?.infodoctoken;

  // 新增：存放每個 provider 的 SSO URL
  const [ssoUrls, setSsoUrls] = useState<{ [id: string]: string }>({});
  const [defaultSsoUrl, setDefaultSsoUrl] = useState<string>("");

  // 新增：取得 UserToken
  async function getUserToken(): Promise<string> {
    let token = '';
    if (infodoctoken) {
      // 如果有 infodoctoken，直接使用它
      token = infodoctoken;
    } else {
      token = localStorage.getItem("UserToken") || '';
      /*
      if (!token || token.trim() === "") {
        // return "eyJhbGciOiJSUzI1NiIsImtpZCI6IjEyMzQ1Njc4OTAxMjM0NTY3ODkwMTIzNDU2Nzg5MDEyIiwidHlwIjoiSldUIn0.eyJzdWIiOiJhNDYzYTY3Ni1iNDQxLTRkYzQtYjUwYi1mYjJlNTEzMzZmMGMiLCJuYW1lIjoiZGVtby11c2VyIiwiVXNlcklkIjoiYTQ2M2E2NzYtYjQ0MS00ZGM0LWI1MGItZmIyZTUxMzM2ZjBjIiwiUm9sZXMiOiJVc2VyIiwiRGlzcGxheU5hbWUiOiIiLCJBdmF0YXJVcmwiOiIiLCJpYXQiOjE3NTIxMzQ2NTEsImlzcyI6Imh0dHBzOi8vb2lkYy5wcm92aWRlcjo1MDAwIiwiYXVkIjpbIlJlcGFpcmluZ1N5c3RlbUF1ZGllbmNlIiwiUmVwYWlyaW5nU3lzdGVtQXVkaWVuY2UiXSwiYXpwIjoicmVwYWlyaW5nLWZyb250ZW5kIiwiYXV0aF90aW1lIjoxNzUyMTM0NjUxLCJub25jZSI6ImI0NzNmMzE1MzU2ZTQ2Y2ZhYzg2MWYzZjlhMzhhZmMzIiwibmJmIjoxNzUyMTM0NjUxLCJleHAiOjE3NTIxMzY0NTF9.sS_dObfP57QiBCTNRotkNlslXEgFN0tyxVz2UT-qhNh1qpzH86Q4VuDtShthV2PB0meE32herwYfFpLBHZbayWbGnyQBk0lgMMsvAlh9txXGnAjdFWIrCcM_NXBs4wRxRYB3C_ohKooPIY72HNfrDYx_VS9YiKn1xWpW6SQT0Tvvgu8xwSOBiDY9oOPKa0fmA7vG5GQ3naTxlKOcmmG1s5kbk79BsaqQOdxIQ73nYC1FDUPY1vHiuXu7xnbSl44NTBUD-3hdctci88FY1tzzlX7OoPRwcmoPsvC29C_FFxnqiBg4uy0gZKjG_cIKWWkjMEBF6R-ihhRMf_rgrcK1zA";
        return "eyJhbGciOiJSUzI1NiIsImtpZCI6IjEyMzQ1Njc4OTAxMjM0NTY3ODkwMTIzNDU2Nzg5MDEyIiwidHlwIjoiSldUIn0.eyJzdWIiOiIxZDNlZDIzYy0xODZhLTRhNWYtOGRkNS1mYzBhM2Y0Y2VhYzQiLCJuYW1lIjoiZGVtby11c2VyMiIsInByZWZlcnJlZF91c2VybmFtZSI6ImRlbW8tdXNlcjIiLCJVc2VySWQiOiIxZDNlZDIzYy0xODZhLTRhNWYtOGRkNS1mYzBhM2Y0Y2VhYzQiLCJSb2xlcyI6IlVzZXIsQ1MiLCJEaXNwbGF5TmFtZSI6IiIsIkF2YXRhclVybCI6IiIsImlhdCI6MTc1MzE4Mjg3NiwiaXNzIjoiaHR0cHM6Ly9vaWRjLnByb3ZpZGVyOjUwMDAiLCJhdWQiOlsiUmVwYWlyaW5nU3lzdGVtQXVkaWVuY2UiLCJSZXBhaXJpbmdTeXN0ZW1BdWRpZW5jZSJdLCJhenAiOiJyZXBhaXJpbmctZnJvbnRlbmQiLCJhdXRoX3RpbWUiOjE3NTMxODI4NzYsIm5vbmNlIjoiZTY1YTIyOThhMmFmNDRmMDhlMmI3YTM3MGE4ZmQ3MGUiLCJuYmYiOjE3NTMxODI4NzYsImV4cCI6MTc1MzE4NDY3Nn0.Wsv8HDHySLmYdTi9KejmI6Kp8xjxkNQic37BfHOXcfai9fmWolneex-aDYASHf80ihQgpwlcedAghkKK_BUPbpJTwLXI8w3spjLS7FB1LKx87F4AKVxfRVwlmRVVDXdiwPH3nciGOV3_NbyGfTnCFukMV9PnTgFvSyQaGv3zoswXUcLygtvN9NLWt2SVAmh0NOKtJT375qdg_nVUVrC2RheGQhRoxkdBGbv8C9a7RGv01y9ZSFso26Aj2b629NN4UEtOyvbQSuo46XqJiQ8IsO5iJI1ecpSNBUwpnMDclED3ceGH4YpjhXpFvKdV2XbBhxX3Q8pQqfgEgFOxm_JIgw";
      }
      */
    }
    return token;
  }

  function clearBeforeSSO() {
    // 防止重複清
    if (sessionStorage.getItem('sso_cleanup_done')) return;
    sessionStorage.setItem('sso_cleanup_done', 'true');

    sessionStorage.clear();

    try {
      indexedDB.deleteDatabase('web-sync-store');
      indexedDB.deleteDatabase('crypto-store');
    } catch {
      // ignore
    }
  }


  // getSSOIdUrl 需用 useCallback 以避免 useEffect 依賴警告
  const getSSOIdUrl = React.useCallback(async (ssoId?: string): Promise<string> => {
    const url = mx.getSsoLoginUrl(redirectUrl, 'sso', ssoId);
    const token = await getUserToken();
    const urlObj = new URL(url);
    urlObj.searchParams.append('token', token);
    return urlObj.toString();
  }, [mx, redirectUrl]);

  const withoutIcon = providers
    ? providers.find(
      (provider) => !provider.icon || !mx.mxcUrlToHttp(provider.icon, 96, 96, 'crop', false)
    )
    : true;

  const renderAsIcons = withoutIcon ? false : saveScreenSpace && providers && providers.length > 2;


  useEffect(() => {
    let isMounted = true;
    async function fetchUrls() {
      if (providers) {
        const entries = await Promise.all(
          providers.map(async (provider) => [provider.id, await getSSOIdUrl(provider.id)])
        );
        if (isMounted) setSsoUrls(Object.fromEntries(entries));
      }
      const url = await getSSOIdUrl();

      if (isMounted) {
        setDefaultSsoUrl(url);
      }
    }
    fetchUrls();
    return () => { isMounted = false; };
  }, [providers, redirectUrl, baseUrl, getSSOIdUrl]);


  useEffect(() => {
    if (buildConfig.enableWidgetMode) {
      const hasRedirected = sessionStorage.getItem("hasRedirectedToSSO");
      if (defaultSsoUrl && !hasRedirected) {
        sessionStorage.setItem("hasRedirectedToSSO", "true");
        window.location.href = defaultSsoUrl;
      }
    }
  }, [defaultSsoUrl]);

  return (
    <Box justifyContent="Center" gap="600" wrap="Wrap">
      {providers ? (
        providers.map((provider) => {
          const { id, name, icon } = provider;
          const iconUrl = icon ? mx.mxcUrlToHttp(icon, 96, 96, 'crop', false) : undefined;
          const buttonTitle = `Continue with ${name}`;

          if (renderAsIcons) {
            return (
              <Avatar
                style={{ cursor: 'pointer' }}
                key={id}
                as="button"
                onClick={() => {
                  clearBeforeSSO();
                  window.location.href = ssoUrls[id];
                }}
                aria-label={buttonTitle}
                size="300"
                radii="300"
              >
                {iconUrl && (
                  <AvatarImage src={iconUrl} alt={name} title={buttonTitle} />
                )}
              </Avatar>
            );
          }

          return (
            <Button
              style={{ width: '100%' }}
              key={id}
              as="button"
              onClick={() => {
                clearBeforeSSO();
                window.location.href = ssoUrls[id];
              }}
              size="500"
              variant="Secondary"
              fill="Soft"
              outlined
              before={
                iconUrl && (
                  <Avatar size="200" radii="300">
                    <AvatarImage src={iconUrl} alt={name} />
                  </Avatar>
                )
              }
            >
              <Text align="Center" size="B500" truncate>
                {buttonTitle}
              </Text>
            </Button>
          );
        })
      ) : (
        <Button
          style={{ width: '100%' }}
          as="a"
          href={defaultSsoUrl || '#'}
          size="500"
          variant="Secondary"
          fill="Soft"
          outlined
        >
          <Text align="Center" size="B500" truncate>
            Continue with SSO
          </Text>
        </Button>
      )}
    </Box>
  );
}
